import { mapState } from "vuex";

export default permissionName => {
  return {
    data: () => ({
      previousRoute: null
    }),
    computed: {
      ...mapState("account", {
        permissions: "permissions",
        shopInfo: "shopInfo"
      })
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.previousRoute = from;
        // if (permissionName == "analytics" && vm.shopInfo.developmentStore) {
        //   vm.$router.replace({ name: "Dashboard" });
        // }
        if (!vm.permissions[permissionName]) {
          if (from.name != "Pricing") vm.$router.replace({ name: "Pricing" });
          else vm.$router.replace({ name: "Dashboard" });
        }
        return true;
      });
    }
  };
};
